import { createContext } from '@/utils';
import type { EntriesContextValue } from './types';

export const EntriesContext = createContext<EntriesContextValue | undefined>(
  undefined,
  'EntriesContext'
);
